import isResultFromArchiveFanout from './isResultFromArchiveFanout';
import type { ItemRow } from 'owa-graph-schema';

/**
 * Whether the mailbox a search-result item lives in is known with certainty.
 *
 * Archive-fanout results resolve their mailbox authoritatively from MailboxGuids, and results that
 * carry an explicit ItemId.mailboxInfo are already scoped to the right store. Any other search
 * result falls back to the table's mailbox, which is a guess that can misroute a cross-store id and
 * make GetItem fail with ErrorInvalidIdMalformed, so its mailbox is not certain.
 */
export default function isSearchResultItemMailboxCertain(item: ItemRow): boolean {
    if (item?.MailboxGuids && isResultFromArchiveFanout(item.MailboxGuids)) {
        return true;
    }

    return !!item.ItemId?.mailboxInfo;
}
